import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'vant/lib/index.css'
import './styles/index.less'
import Vant from 'vant'
import 'vant/lib/index.css'
import '@/utils/rem'
import VueClipboard from 'vue-clipboard2'

import { getConnectKey } from '@/utils/utils'
Vue.config.productionTip = false

if (process.env.NODE_ENV != 'production') {
  const vConsole = new VConsole()
  Vue.use(vConsole)
}

Vue.use(Vant)
Vue.use(VueClipboard)

import {
  WSBridge,
  platformAgent,
  getKey,
  publicKey,
  data1
} from '@/utils/utils'
import { JSEncrypt } from 'jsencrypt'

if (window.webkit || window.syjs) {
  SyHybridSdk.encryptfun().then(res => {
    init()
  })
} else {
  init()
}

function init() {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}

// let encrypt = new JSEncrypt()
// encrypt.setPublicKey(publicKey)
// let value1 = encrypt.encrypt(data1)
// const platform = platformAgent()
// let val = ''
// if (platform === 'android') {
//   val = window.syjs.nativeEncryKey(value1)
//   getKey(val)
//   init()
// } else if (platform === 'ios') {
//   let params = {
//     params: {
//       value: value1 // 加密过
//     },
//     success: res => {
//       getKey(res)
//       init()
//     },
//     fail: err => {
//       alert('获取密钥失败')
//     }
//   }
//   WSBridge.nativeEncryKey(params)
// }
